<template>
  <v-app>
    <v-content class="login">
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4>
            <v-card class="elevation-12">
              <v-toolbar dark color="primary">
                <v-toolbar-title></v-toolbar-title>
              </v-toolbar>
              <v-form @submit.prevent="login" ref="form">
                <v-card-text>
                  <v-text-field
                    autofocus
                    prepend-icon="person"
                    name="login"
                    label="Email"
                    type="text"
                    v-model="email"
                    :rules="[rules.required, rules.email]"
                  ></v-text-field>
                  <v-text-field
                    id="password"
                    prepend-icon="lock"
                    name="password"
                    label="Senha"
                    v-model="password"
                    :type="showPassword ? 'text' : 'password'"
                    :append-icon="showPassword ? 'visibility_off' : 'visibility'"
                    :rules="[rules.required]"
                    @click:append="showPassword = !showPassword"
                  ></v-text-field>
                </v-card-text>
                <v-card-actions>
                  <v-btn flat small to="recover" color="blue-grey lighten-1">Esqueci a minha senha</v-btn>
                  <v-spacer></v-spacer>
                  <v-btn type="submit" color="primary" :loading="loading">Entrar</v-btn>
                </v-card-actions>
              </v-form>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import firebase from 'firebase/app';
import 'firebase/auth';
import database from "@/services/database";

export default {
  name: "login",
  data() {
    return {
      email: "",
      password: "",
      loading: false,
      showPassword: false,
      rules: {
        required: v => !!v || "requerido",
        email: v =>
          /^\w+([+.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,4})+$/.test(v) ||
          "email inválido"
      }
    };
  },
  methods: {
    login: async function() {
      if (!this.$refs.form.validate()) {
        return;
      }
      this.loading = true;
      try {
        let snapshot = await database
          .collection("users")
          .where("email", "==", this.email)
          .get();

        let role;
        if (snapshot.size == 1) {
          role = snapshot.docs[0].data().role;
        } else {
          throw "O usuário não existe";
        }

        await firebase
          .auth()
          .signInWithEmailAndPassword(this.email, this.password);

        switch (role) {
          case "admin":
            this.$router.replace("/admin/partners");
            break;
          case "partner":
            this.$router.replace("/partner/validate");
            break;
          default:
            throw "Error";
        }
      } catch (err) {
        alert("O usuário não existe ou a senha está incorreta.");
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style>
#app.application {
  background-image: url(https://secureservercdn.net/198.71.233.199/dpp.482.myftpupload.com/wp-content/uploads/2020/04/cropped-qtq80-f8yfBQ.jpeg);
  background-size: cover;
}

.v-content.login {
  background-color: rgba(0, 0, 0, 0.4);
}

nav.v-toolbar {
  background-image: url(/logo-novo.png);
  background-size: 5rem;
  background-position: 1rem center;
}
</style>
